import { calculatePermanentDamage } from './permanentDamage';
import { parseAmount } from './currencyInput';

export function calculateDamageAssessment(box, eta, parametri, responsabilitaControparte, differential = null) {
    // Converti tutti i valori in numeri
    const permanente = calculatePermanentDamage(box.dannoBiologico, eta, parametri.valore_punto_micro, box.moraleBiologico, parametri.coefficienti_eta);
    const preexisting = differential ? Number(differential.preexisting) : 0;
    const previous = differential ? calculatePermanentDamage(preexisting, eta, parametri.valore_punto_micro, null, parametri.coefficienti_eta) : null;
    const rounded = value => Number(value.toFixed(2));
    const differentialDetails = differential ? {preexisting, final: Number(box.dannoBiologico), before: rounded(previous.biologico), after: rounded(permanente.biologico)} : null;
    const dannoBiologicoValore = differential ? differentialDetails.after - differentialDetails.before : permanente.biologico;
    const dannoBiologicoArrotondato = parseFloat(dannoBiologicoValore.toFixed(2));
  
    // Calcolo del danno morale su biologico
    let dannoMoraleBiologicoArrotondato = 0;
    if (box.moraleBiologico) {
      const moralAmount = differential ? dannoBiologicoArrotondato * (permanente.biologico > 0 ? permanente.morale / permanente.biologico : 0) : permanente.morale;
      dannoMoraleBiologicoArrotondato = rounded(moralAmount);
    }
  
    // Calcolo del danno temporaneo
    const valoreGiorno100 = Number(parametri.valore_giorno_micro);
    const dannoTemporaneo =
      parseFloat(box.giorni100 || 0) * valoreGiorno100 * 1 +
      parseFloat(box.giorni75 || 0) * valoreGiorno100 * 0.75 +
      parseFloat(box.giorni50 || 0) * valoreGiorno100 * 0.50 +
      parseFloat(box.giorni25 || 0) * valoreGiorno100 * 0.25;
    const dannoTemporaneoArrotondato = parseFloat(dannoTemporaneo.toFixed(2));
  
    // Calcolo del danno morale su temporaneo
    const dannoMoraleTemporaneoArrotondato = parseFloat((dannoTemporaneo * (parseFloat(box.moraleTemporaneo || 0) / 100)).toFixed(2));
  
    // Totale complessivo
    const totale = parseFloat((
      dannoBiologicoArrotondato +
      dannoMoraleBiologicoArrotondato +
      dannoTemporaneoArrotondato +
      dannoMoraleTemporaneoArrotondato +
      parseAmount(box.speseMediche) +
      parseAmount(box.speseAccessorie) +
      parseAmount(box.mancatoGuadagno) +
      parseAmount(box.dannoMateriale)
    ).toFixed(2));
    const responsabilita = Number(String(responsabilitaControparte ?? '').replace(',', '.'));
    const responsabilitaDefinita = responsabilitaControparte !== '' && responsabilitaControparte != null && Number.isFinite(responsabilita);
    const totaleSpettante = responsabilitaDefinita ? parseFloat((totale * responsabilita / 100).toFixed(2)) : null;
  
    return {
      ...(differentialDetails ? {differential: differentialDetails} : {}),
      dannoBiologico: dannoBiologicoArrotondato,
      dannoMoraleBiologico: dannoMoraleBiologicoArrotondato,
      dannoTemporaneo: dannoTemporaneoArrotondato,
      dannoMoraleTemporaneo: dannoMoraleTemporaneoArrotondato,
      speseMediche: parseAmount(box.speseMediche),
      speseAccessorie: parseAmount(box.speseAccessorie),
      mancatoGuadagno: parseAmount(box.mancatoGuadagno),
      dannoMateriale: parseAmount(box.dannoMateriale),
      totale: totale,
      responsabilitaControparte: responsabilitaDefinita ? responsabilita : null,
      totaleSpettante,
    };
}
